import React from 'react';
import { hot } from 'react-hot-loader';

export default hot(module)(function Footer() {
	return (
		<footer className="main-footer">
			<div className="float-right d-none d-sm-block">{/* <b>Version</b> 3.0.4 */}</div>
			{/* <strong>Copyright © 2014-2019</strong> */}
		</footer>
	);
});
